import { CookieInfoApi } from 'src/app/models/api.model'
import { CookieInfoApiService } from './cookie-info-api.service'

export class ESMApiService {
  private static instance: ESMApiService
  private readonly cookieInfoApiService: CookieInfoApiService

  private constructor() {
    this.cookieInfoApiService = CookieInfoApiService.getInstance()
  }

  static getInstance(): ESMApiService {
    if (ESMApiService.instance === undefined) {
      ESMApiService.instance = new ESMApiService()
    }

    return ESMApiService.instance
  }

  getPublicApi(): CookieInfoApi {
    return this.cookieInfoApiService.getInitialPublicApi()
  }
}
